import React, { useEffect, useState } from "react";
import {
  Modal,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Card,
  Typography,
} from "@mui/material";
import ImageModal from "components/ImageModal";
import apiClient from "./apiClient";

// Legacy Firebase implementation kept during the backend migration:
// import { getDatabase, ref, get } from "firebase/database";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  maxHeight: "85vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 3,
  p: 2,
  overflowY: "auto",
};

const UserAssetsModal = ({ open, onClose, userId }) => {
  const [assets, setAssets] = useState([]);
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);
  const [clickedImage, setClickedImage] = useState("");

  const fetchUserAssets = async () => {
    try {
      const response = await apiClient.get("/help-track/totalassets", {
        params: { userId },
      });
      const filtered = Array.isArray(response?.data) ? response.data : [];
      setAssets(
        filtered.map((item) => ({
          assetId: item?.id || item?._id || item?.assetId || "",
          ...item,
        })),
      );
    } catch (error) {
      setAssets([]);
    }
  };

  useEffect(() => {
    if (open && userId) fetchUserAssets();
  }, [open, userId]);

  const handleImageClick = (img) => {
    setClickedImage(img);
    setIsImageModalOpen(true);
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <Card sx={{ borderRadius: 3, p: 2, position: "relative" }}>
          <button
            onClick={onClose}
            style={{
              position: "absolute",
              top: 10,
              right: 12,
              background: "transparent",
              border: "none",
              fontSize: "18px",
              cursor: "pointer",
              fontWeight: "bold",
            }}
          >
            ✕
          </button>

          <Typography variant="h6" align="center" sx={{ fontWeight: "bold", mb: 2 }}>
            Registered Asset
          </Typography>

          {assets.length > 0 ? (
            <TableContainer component={Paper}>
              <Table sx={{ "& td, & th": { fontSize: "13px", padding: "10px" } }}>
                <TableBody>
                  <TableRow>
                    {[
                      "S/N",
                      "Asset Type",
                      "Brand/Model",
                      "Plate Number",
                      "Color",
                      "Photo",
                      "Proof of Ownership",
                    ].map((header) => (
                      <TableCell key={header} align="center" sx={{ fontWeight: "bold" }}>
                        {header}
                      </TableCell>
                    ))}
                  </TableRow>

                  {assets.map((a, index) => (
                    <TableRow key={a.assetId} hover>
                      <TableCell align="center">{index + 1}</TableCell>
                      <TableCell align="center">{a.assetType || "N/A"}</TableCell>
                      <TableCell align="center">{a.brandModel || "N/A"}</TableCell>
                      <TableCell align="center">{a.plateNumber || "N/A"}</TableCell>
                      <TableCell align="center">{a.color || "N/A"}</TableCell>

                      <TableCell align="center">
                        {Array.isArray(a.vehicleImgs) && a.vehicleImgs.length > 0 ? (
                          <div
                            style={{
                              display: "flex",
                              gap: "6px",
                              justifyContent: "center",
                              flexWrap: "wrap",
                            }}
                          >
                            {a.vehicleImgs.map((img, i) => (
                              <img
                                key={i}
                                src={img}
                                alt="car"
                                width={40}
                                height={40}
                                style={{
                                  borderRadius: 5,
                                  border: "1px solid #ddd",
                                  objectFit: "cover",
                                  cursor: "pointer",
                                }}
                                onClick={() => handleImageClick(img)}
                              />
                            ))}
                          </div>
                        ) : (
                          "N/A"
                        )}
                      </TableCell>

                      <TableCell align="center">
                        {a.ownershipImg ? (
                          <img
                            src={a.ownershipImg}
                            alt="Proof"
                            width={40}
                            height={40}
                            style={{
                              borderRadius: 5,
                              border: "1px solid #ddd",
                              cursor: "pointer",
                              objectFit: "cover",
                            }}
                            onClick={() => handleImageClick(a.ownershipImg)}
                          />
                        ) : (
                          "N/A"
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Typography align="center" sx={{ py: 3, fontStyle: "italic" }}>
              No assets found.
            </Typography>
          )}
        </Card>

        <ImageModal
          isModalOpen={isImageModalOpen}
          onClose={() => setIsImageModalOpen(false)}
          onClickImageData={clickedImage}
        />
      </Box>
    </Modal>
  );
};

export default UserAssetsModal;
